// src/components/AboutSection.jsx
import React from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Chip,
  Typography,
} from "@mui/material";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import SectionHeader from "./SectionHeader";

const AboutSection = () => (
  <Box id="about" sx={{ py: { xs: 6, md: 8 } }}>
    <Container maxWidth="lg">
    <Grid container spacing={6} alignItems="center">
      {/* LEFT SIDE - your existing content */}
      <Grid item xs={12} md={6}>
        <SectionHeader subtitle="About" title="What is Carbon Bridge Computing?" />

        <Typography sx={{ mb: 2 }}>
          Carbon Bridge Computing is an infrastructure layer for high-integrity carbon
          markets, combining hardware-grade measurement, blockchain computing and AI
          analytics to create a trusted digital twin of your renewable-energy and
          emissions data.
        </Typography>

        <Typography sx={{ mb: 2 }}>
          Our platform connects secure IoT meters, data pipelines and smart contracts
          into a single verifiable lifecycle. Every energy reading is signed at the
          device, transformed into tokens on an energy-aware blockchain, and then
          certified as carbon credits with full provenance.
        </Typography>

        <Typography>
          We’re building for regulators, auditors and operators who need proof, not
          PDFs - making it simple to track, verify and retire carbon outcomes without
          manual spreadsheets.
        </Typography>
      </Grid>

      {/* RIGHT SIDE - NEW image block */}
      <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
        <Box
          component="img"
          src="/images/about.jpg"
          alt="Carbon Bridge overview"
          sx={{
            width: "100%",
            maxWidth: 480,
            borderRadius: 2,
            boxShadow: 3,
          }}
        />
      </Grid>
    </Grid>
    </Container>
  </Box>
);

export default AboutSection;
